module.exports = __webpack_public_path__ + "static/media/nb5.c00e3c1b.jpg";